var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modal fade"tabindex="-1"role="dialog"> <div class="modal-dialog"data-bind="css: options.css"> <div class="modal-content"> <div class="modal-header"><!-- ko if: options.userCanClose --> <button type="button"class="close"data-dismiss="modal"aria-hidden="true"> × </button><!-- /ko --> <h4 class="modal-title"> <b data-bind="text: options.title"></b> </h4> </div> <div class="modal-body"data-bind="template: options.template"></div> </div> </div> </div>';
}
return __p;
};
